module.exports = __webpack_public_path__ + "img/barcode.21a24ef2.svg";